module.exports = __webpack_public_path__ + "static/media/NFT filled icon.9a67af68.svg";